import {
  useState,
  useEffect,
  useCallback,
} from 'react';
import {
  getStakingDetail,
  getStakingHoldHistory,
  getStakingList,
  getStakingRebate,
} from './api';
import { defaultStake } from './constants';

export const useStakingList = ({ topNumber = 0 } = {}) => {
  const [stakes, updateStakes] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const stakeList = await getStakingList();
      const topStakes = stakeList.slice(0, topNumber);
      updateStakes(topNumber ? topStakes : stakeList);
      setLoading(false);
    };
    fetchData();
  }, []);

  return {
    stakes,
    isLoading,
  };
};

export const useStakingDetail = ({ stakingId }) => {
  const [stake, updateStake] = useState(defaultStake);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      updateStake(await getStakingDetail({ stakingId }));
      setLoading(false);
    };
    fetchData();
  }, [stakingId]);

  return {
    stake,
    isLoading,
  };
};

export const useStakingRebate = ({ pageSize = 4 }) => {
  const [rebates, updateRebates] = useState([]);
  const [pagination, updatePagination] = useState({ total: 0, current: 0, pageSize });
  const [isLoading, setLoading] = useState(false);

  const fetchData = useCallback(async (curPage = 1) => {
    if (isLoading) return;
    setLoading(true);
    const {
      data,
      total,
    } = await getStakingRebate({ pageNum: curPage, pageSize });
    updateRebates(data);
    updatePagination({
      total,
      current: curPage,
      pageSize,
    });
    setLoading(false);
  }, [isLoading, setLoading, updatePagination, updateRebates, pageSize]);

  return {
    rebates,
    isLoading,
    pagination,
    fetchData,
  };
};

export const useStakingHoldSnapshot = ({ assetName, pageNum = 1 }) => {
  const [snapshots, updateSnapshots] = useState([]);
  const [holdCoinTotal, updateHoldCoinTotal] = useState('');
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const {
        userKeepCoins,
        holdCoinTotal: coinTotal,
      } = await getStakingHoldHistory({ assetName, pageNum });
      updateSnapshots(userKeepCoins);
      updateHoldCoinTotal(coinTotal);
      setLoading(false);
    };
    fetchData();
  }, [assetName]);

  return {
    snapshots,
    holdCoinTotal,
    isLoading,
  };
};
